
/** @return {string|undefined} */
const getSkuId = (selectedCharacteristic) => {
    if (selectedCharacteristic == null || typeof selectedCharacteristic != 'object') {
        return undefined;
    }
    if (typeof selectedCharacteristic.skuId == 'string') {
        return selectedCharacteristic.skuId.trim();
    }
    return undefined;
}

/** @return {string|null} */
export const getRedirectUrlToDevicePage = (device, selectedCharacteristic) => {
    if (device == null || typeof device != 'object') {
        return null;
    }
    if (typeof device.productUrl != 'string') {
        return null;
    }
    const url = new URL(device.productUrl, device.productUrl.startsWith('http') ? undefined : window.location.origin);

    const skuId = getSkuId(selectedCharacteristic)
    if (url.searchParams.has('skuId') && skuId != null) {
        url.searchParams.set('skuId', skuId);
    }

    return device.productUrl.startsWith('http')
        ? url.toString()
        : url.toString().replace(url.origin, '');
}